import { getReducerErrorMessage } from 'src/utils/helpers'

const initialState = {
  email: '',
  setEmailTimestamp: 0,
  user: null,
  otherUsers: [],
  loadingOtherUsers: false,
  isSaveSlipConsentInProgress: false,
  saveSlipConsentResponse: {},
  // How did someone log in: PIN (logInPin), "Login as Kiosk user" (logInAsKioskUserLink), login from email link (logInFromEmailLink)
  userLastAccessType: null,
  isGetUserPushSettingsInProgress: false,
  submitGetUserPushSettingsResponse: {},
  getUserPushSettingsPayload: {},
  isSaveUserPushSettingsInProgress: false,
  submitSaveUserPushSettingsResponse: {},
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_USER': {
      return {
        ...initialState,
        // Preserve this state
        userLastAccessType: state.userLastAccessType,
      }
    }

    case 'SET_EMAIL': {
      return {
        ...state,
        email: action.payload.email,
        setEmailTimestamp: new Date().getTime(),
      }
    }

    case 'CLEAR_EMAIL': {
      return {
        ...state,
        email: '',
        setEmailTimestamp: 0,
      }
    }

    case 'SET_USER': {
      return {
        ...state,
        user: action.payload.user,
      }
    }

    case 'GET_OTHER_USERS': {
      return {
        ...state,
        loadingOtherUsers: true,
      }
    }

    case 'GET_OTHER_USERS_COMMIT': {
      return {
        ...state,
        loadingOtherUsers: false,
        otherUsers: action.payload && action.payload.data ? action.payload.data : [],
      }
    }

    case 'GET_OTHER_USERS_ROLLBACK': {
      return {
        ...state,
        loadingOtherUsers: false,
      }
    }

    case 'SAVE_PINK_SLIP_CONSENT': {
      return {
        ...state,
        isSaveSlipConsentInProgress: true,
        saveSlipConsentResponse: {},
      }
    }
    case 'SAVE_PINK_SLIP_CONSENT_COMMIT': {
      return {
        ...state,
        isSaveSlipConsentInProgress: false,
        saveSlipConsentResponse: {
          success: true,
        },
      }
    }
    case 'SAVE_PINK_SLIP_CONSENT_ROLLBACK': {
      return {
        ...state,
        isSaveSlipConsentInProgress: false,
        saveSlipConsentResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'SET_PINK_SLIP_CONSENT': {
      return {
        ...state,
        user: {
          ...state.user,
          hasSlipConsent: action.payload.hasSlipConsent,
        },
      }
    }

    case 'SET_USER_LAST_ACCESS_TYPE': {
      return {
        ...state,
        userLastAccessType: action.payload.userLastAccessType,
      }
    }

    case 'GET_USER_NOTIFICATION_SETTINGS': {
      return {
        ...state,
        isGetUserPushSettingsInProgress: true,
        submitGetUserPushSettingsResponse: {},
      }
    }
    case 'GET_USER_NOTIFICATION_SETTINGS_COMMIT': {
      return {
        ...state,
        isGetUserPushSettingsInProgress: false,
        submitGetUserPushSettingsResponse: {
          success: true,
        },
        getUserPushSettingsPayload: action.payload,
      }
    }
    case 'GET_USER_NOTIFICATION_SETTINGS_ROLLBACK': {
      return {
        ...state,
        isGetUserPushSettingsInProgress: false,
        submitGetUserPushSettingsResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'SAVE_USER_NOTIFICATION_SETTINGS': {
      return {
        ...state,
        isSaveUserPushSettingsInProgress: true,
        submitSaveUserPushSettingsResponse: {},
      }
    }
    case 'SAVE_USER_NOTIFICATION_SETTINGS_COMMIT': {
      return {
        ...state,
        isSaveUserPushSettingsInProgress: false,
        submitSaveUserPushSettingsResponse: {
          success: true,
        },
      }
    }
    case 'SAVE_USER_NOTIFICATION_SETTINGS_ROLLBACK': {
      return {
        ...state,
        isSaveUserPushSettingsInProgress: false,
        submitSaveUserPushSettingsResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    default: {
      return state
    }
  }
}
